import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Single shared MSAL instance for the whole app. `initialize()` must be
// awaited before any other MSAL method is called (handled in auth.js).
export const msalInstance = new PublicClientApplication(msalConfig);
